import React, { useState } from 'react';
import style from '../content-list.module.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from '../../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import { AdaptiveCard  } from './AdaptiveCard';
import { AdaptiveCard as TAdaptiveCard } from '../../types';
import { AddAdaptiveCard } from './AddAdaptiveCard';
import { usePermissions } from '../../../../hooks';

type Props = {
	scrollRef:any|null;
	contents: (TAdaptiveCard & { id: string; updatedAt: string|null; createdAt: string })[];
	hasMore:boolean;
	refetchContent: () => void;
	loadMore: () => void;
};

export function AdaptiveCardList(props: Props) {
	const { scrollRef, contents: cards, hasMore, refetchContent, loadMore } = props;
 
	return (
		<div className={style.contentList}>
			<Header {...props} />
			<div className={style.selector}>
				<div>
					<p>Adaptive Card</p>
				</div>
				<p>Updated At</p>
				<p>Created At</p>
			</div>
			<div id="infiniteScrollTarget"  ref={scrollRef} className={style.textList} style={{overflow: "auto", height: "calc(100vh - 200px)"}}>
				{cards.length>0?
					<InfiniteScroll
						dataLength={cards.length}
						next={loadMore}
						hasMore={hasMore}
						scrollableTarget="infiniteScrollTarget"
						loader={<div className={style.loadingContainer}>Loading...</div>}>
						{cards.map((el) => (
							<AdaptiveCard key={el.id} card={el} refetchContent={refetchContent} />
						))}
					</InfiniteScroll>
				:
					null
				}
			</div>
		</div>
	);
}

function Header(props: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const canCreate = usePermissions('content.Create')
	return (
		<div className={style.header}>
			{canCreate &&
				<button className={style.add} onClick={() => setIsOpen(true)}>
					<img src={AddIcon} alt="add" />
					<span>Add Adaptive Card</span>
				</button>
			}
			{isOpen && (
				<AddAdaptiveCard
					isOpen={isOpen}
					close={() => setIsOpen(false)}
					refetchContent={props.refetchContent}
				/>
			)}
		</div>
	);
}
